import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcCheckCircle32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m16 2c7.719 0 14 6.281 14 14s-6.281 14-14 14-14-6.281-14-14 6.281-14 14-14zm0 2c-6.625 0-12 5.375-12 12s5.375 12 12 12 12-5.375 12-12-5.375-12-12-12zm6.973 6.563a.972.972 0 0 0 -.692.28l-8.718 8.75-3.813-3.812c-.226-.211-.464-.296-.69-.296-.551 0-1.02.454-1.02 1.015 0 .258.1.516.304.719l4.5 4.5.094.062c.188.145.41.216.629.216a.962.962 0 0 0 .683-.278l9.438-9.438c.238-.238.331-.482.331-.71 0-.534-.48-1.008-1.046-1.008z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcCheckCircle32;
